import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";
import {
  getEventsThunk,
} from "../../../store/events/eventThunk";
import { EVENT_TYPE } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";

const DirectRequest = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventsThunk({
        type: EVENT_TYPE.DIRECT_REQUEST,
        isLoading: false,
      })
    );

  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      await dispatch(
        getEventsThunk({
          type: EVENT_TYPE.DIRECT_REQUEST,
          isLoading: true,
        })
      );
      setShouldStartUpdating(true);
    };
    getData();
  }, []);
  return (
    <EventGrid
      gridId={`EVENT_DIRECT_REQUEST`}
      eventType={"DIRECT_REQUEST"}
      showSave={false}
      title={"Direct Requests"}
      queryParams={ROUTE_QUERY_CONSTANTS.DirectRequests}
    />
  );
};

export default DirectRequest;
